/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityProviderSettingsStateResponse
 */
export interface IdentityProviderSettingsStateResponse {
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsStateResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsStateResponse
     */
    errorMessage?: string | null;
}

export function IdentityProviderSettingsStateResponseFromJSON(json: any): IdentityProviderSettingsStateResponse {
    return IdentityProviderSettingsStateResponseFromJSONTyped(json, false);
}

export function IdentityProviderSettingsStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityProviderSettingsStateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
    };
}

export function IdentityProviderSettingsStateResponseToJSON(value?: IdentityProviderSettingsStateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'errorMessage': value.errorMessage,
    };
}


